import { API_ENDPOINT, QueryKeys } from "@cede/utils";
import { useApi } from "@/hooks/core/useApi";
import { useHubUser } from "@/hooks/user/useHubUser";
import { useMutation } from "@tanstack/react-query";

export const useOAuthFlow = () => {
  const { auth } = useHubUser();
  const apiHelper = useApi();

  const { mutateAsync: initFlow, isPending } = useMutation({
    mutationKey: [QueryKeys.HUB_OAUTH_INIT],
    mutationFn: async (params: { exchangeId: string; successUrl?: string }) => {
      return apiHelper.postAuth(auth, API_ENDPOINT.HUB_OAUTH_INIT, {
        bodyParams: params,
      });
    },
  });

  const startOAuthFlow = async (params: { exchangeId: string; successUrl?: string }) => {
    const { url } = await initFlow(params);
    window.location.href = url;
  };

  return {
    startOAuthFlow,
    isLoading: isPending,
  };
};
